import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';
import moment from 'moment';

import axios from './../../../constants/axios';

class UnpaidBill extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         unpaidBills: []
      };
   }

   componentDidMount() {
      axios.get('fixedAssets/unpaidBills')
         .then((res) => {
            this.setState({
               unpaidBills: res.data
            });
         });
   }

   render() {
      const { unpaidBills } = this.state;
      return (
         <Table >
            <thead >
            <tr >
               <th >#inv Id</th >
               <th >Contact Name</th >
               <th >Amount Billed</th >
               <th >Amount Due</th >
               <th >Inv Created</th >
               <th >##</th >
            </tr >
            </thead >
            <tbody >
            {unpaidBills.map((bill) => (
               <tr key={bill.id} >
                  <td >{bill.id}</td >
                  <td >{bill.contact_name}</td >
                  <td >{bill.total_amount}</td >
                  <td >{bill.paid_amount}</td >
                  <td >{bill.due}</td >
                  <td >{moment(bill.created_at).format('DD/MM/YYYY h:mm a')}</td >
                  <td >
                     <Link to={`/fixedAsset/fixedAssetInvoiceDetail/${bill.id}`} >Details</Link >
                     <Link to={`/fixedAsset/fixedAssetPayBill/${bill.id}`} >Pay</Link >
                  </td >
               </tr >
            ))}
            </tbody >
         </Table >
      );
   }
}


export default UnpaidBill;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/UnpaidBill.js
 **/